"use client";

import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import { cn } from "@/lib/utils";

export const classNameStyles = {
  default:
    "",
} as const;

type StyleKey = keyof typeof classNameStyles;

export interface LabelProps
  extends React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> {
  classType?: StyleKey;
}

export const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  LabelProps
>(({ className, classType = "default", ...props }, ref) => {
  const classes = cn(
    // baseline styles
    "",
    // variant styles
    classType ? classNameStyles[classType] : undefined,
    // allow overrides
    className
  );

  return (
    <LabelPrimitive.Root
      ref={ref}
      className={classes}
      {...props}
    />
  );
});

Label.displayName = LabelPrimitive.Root.displayName;
